module.exports = __webpack_public_path__ + "static/img/avatar.afd095f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar.png
// module id = HfaK
// module chunks = 1